export function RichTextArea(props) {
  return <div>Rich text area</div>;
}
